function numberToFixed(num, fixed = 2) {
  return (Math.round(num * 100) / 100).toFixed(fixed);
}

export default numberToFixed;
